export default __webpack_public_path__ + "static/media/Profile-BG-Removed.55e44ce9.png";